<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndat"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndat'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntim"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntim'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S124G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_26 col_27'><span class='brt high default' id='text3'>BATCH REPORT PRINT REQUEST</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_33 col_01'><span class='brt high default' id='text4'>REQUESTED BATCH REPORT PRINT FOR:</span>  </div>
  <div class='lgr_20 col_50'><dynamic-field [id]='"blnk1"' [size]=20 [line]=5 [column]=50 [(ngModel)]='blnk1'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_20 col_54'><dynamic-field [id]='"blnk2"' [size]=20 [line]=6 [column]=54 [(ngModel)]='blnk2'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_16 col_01'><dynamic-field [id]='"crittyp"' [size]=16 [line]=7 [column]=1 [(ngModel)]='crittyp'></dynamic-field></div>
  <div class='lgr_30 col_18'><dynamic-field [id]='"critdat"' [size]=30 [line]=7 [column]=18 [(ngModel)]='critdat'></dynamic-field></div>
  <div class='lgr_02 col_50'><dynamic-field [id]='"frmmm"' [size]=2 [line]=7 [column]=50 [(ngModel)]='frmmm'></dynamic-field></div>
  <div class='lgr_01 col_53'><dynamic-field [id]='"blnk3"' [size]=1 [line]=7 [column]=53 [(ngModel)]='blnk3'></dynamic-field></div>
  <div class='lgr_02 col_55'><dynamic-field [id]='"frmdd"' [size]=2 [line]=7 [column]=55 [(ngModel)]='frmdd'></dynamic-field></div>
  <div class='lgr_01 col_58'><dynamic-field [id]='"blnk4"' [size]=1 [line]=7 [column]=58 [(ngModel)]='blnk4'></dynamic-field></div>
  <div class='lgr_02 col_60'><dynamic-field [id]='"frmyy"' [size]=2 [line]=7 [column]=60 [(ngModel)]='frmyy'></dynamic-field></div>
  <div class='lgr_02 col_67'><dynamic-field [id]='"tomm"' [size]=2 [line]=7 [column]=67 [(ngModel)]='tomm'></dynamic-field></div>
  <div class='lgr_01 col_70'><dynamic-field [id]='"blnk5"' [size]=1 [line]=7 [column]=70 [(ngModel)]='blnk5'></dynamic-field></div>
  <div class='lgr_02 col_72'><dynamic-field [id]='"todd"' [size]=2 [line]=7 [column]=72 [(ngModel)]='todd'></dynamic-field></div>
  <div class='lgr_01 col_75'><dynamic-field [id]='"blnk6"' [size]=1 [line]=7 [column]=75 [(ngModel)]='blnk6'></dynamic-field></div>
  <div class='lgr_02 col_77'><dynamic-field [id]='"toyy"' [size]=2 [line]=7 [column]=77 [(ngModel)]='toyy'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_05 col_12'><dynamic-field [id]='"blnk7"' [size]=5 [line]=9 [column]=12 [(ngModel)]='blnk7'></dynamic-field></div>
  <div class='lgr_06 col_18'><dynamic-field [id]='"pnrno"' [size]=6 [line]=9 [column]=18 [(ngModel)]='pnrno'></dynamic-field></div>
  <div class='lgr_14 col_27'><dynamic-field [id]='"blnk8"' [size]=14 [line]=9 [column]=27 [(ngModel)]='blnk8'></dynamic-field></div>
  <div class='lgr_08 col_42'><dynamic-field [id]='"crdate"' [size]=8 [line]=9 [column]=42 [(ngModel)]='crdate'></dynamic-field></div>
  <div class='lgr_25 col_54'><dynamic-field [id]='"pnrmsg"' [size]=25 [line]=9 [column]=54 [(ngModel)]='pnrmsg'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_45 col_01'><span class='brt high default' id='text5'>ENTER PRINTER ID OR "NONE" (ONLY SAR VIEWING)</span>  </div>
  <div class='lgr_27 col_47'><span class='brt high default' id='text6'>- PRESS ENTER TO SUBMIT JOB</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_11 col_06'><span class='brt high default' id='text7'>PRINTER ID:</span>  </div>
  <div class='lgr_08 col_18'><dynamic-field [id]='"prnt"' [size]=8 [line]=18 [column]=18 [(ngModel)]='prnt' (keyup.enter)="onEnter()"></dynamic-field></div>
  <div class='lgr_00 col_27'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text9'>PF:</span>  </div>
  <div class='lgr_16 col_21'><span class='brt high default' id='text10'>6-CANCEL PRINT  </span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text11'>SHIFT PF:</span>  </div>
</div>
</div>
